import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import InvestmentDashboard from "./icons/InvestmentDashboard";
import Report from "./icons/Report";
import Research from "./icons/Research";
import Watchlist from "./icons/Watchlist";
import {Timeline as TimelineIcon} from "./icons/Timeline";
import Logout from "./icons/Logout";
import { SESSSION_OUT } from "../../../../Utils/constants";
import FamilyPeople from "./icons/settings/FamilyPeople";

const InvestmentSidebar = (props) => {

  const { t } = useTranslation();
  const location = useLocation();
  const isBank = localStorage.getItem("__bank");
  const activeColor = props.state.theme.values.primaryColor;
  const defaultColor = props.state.theme.values.tertiaryGrayColor;
  
  const logout = () => {
    SESSSION_OUT(props);
  };

  const toggleSidebar = () => {
    document.querySelector('.parent-left-sidebar').classList.toggle('active');
  }

  return (
    <div className="parent-left-sidebar">
      <ul>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/dashboard" ? 'active' : ''}`}>
          <Link to="/parent/dashboard">
            <span className="menu-icon">
              <span className="svgIcon">
                <FamilyPeople {...props} color={location.pathname === "/parent/dashboard" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('my_family')}</span>
          </Link>
        </li>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/investments/dashboard" ? 'active' : ''}`}>
          <Link to="/parent/investments/dashboard">
            <span className="menu-icon">
              <span className="svgIcon">
                <InvestmentDashboard {...props} color={location.pathname === "/parent/investments/dashboard" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('investments')}</span>
          </Link>
        </li>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/investments/timeline" ? 'active' : ''}`}>
          <Link to="/parent/investments/timeline">
            <span className="menu-icon">
              <span className="svgIcon">
              <TimelineIcon {...props} color={location.pathname === "/parent/investments/timeline" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('timeline')}</span>
          </Link>
        </li>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/investments/research" ? 'active' : ''}`}>
          <Link to="/parent/investments/research">
            <span className="menu-icon">
              <span className="svgIcon">
                <Research {...props} color={location.pathname === "/parent/investments/research" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('research')}</span>
          </Link>
        </li>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/investments/watchlist" ? 'active' : ''}`}>
          <Link to="/parent/investments/watchlist">
            <span className="menu-icon">
              <span className="svgIcon">
                <Watchlist {...props} color={location.pathname === "/parent/investments/watchlist" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('investment_watchlist.watchlist')}</span>
          </Link>
        </li>
        <li onClick={toggleSidebar} className={`${location.pathname === "/parent/investments/reports" ? 'active' : ''}`}>
          <Link to="/parent/investments/reports">
            <span className="menu-icon">
              <span className="svgIcon">
                <Report {...props} color={location.pathname === "/parent/investments/reports" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('reports')}</span>
          </Link>
        </li>

        {!isBank && 
        <li onClick={toggleSidebar} className={`${location.pathname === "/dashboard" ? 'active' : ''}`}>
          <a href="#logout" onClick={logout}>
            <span className="menu-icon">
              <span className="svgIcon">
                <Logout {...props} color={location.pathname === "/dashboard" ? activeColor : defaultColor}/>
              </span>
            </span>
            <span>{t('sign_out')}</span>
          </a>
        </li>
        }
      </ul>
    </div>
  );
};

export default InvestmentSidebar;
